<div class="cell">
    <div class="active" (click)="onProjectNameClicked()">{{project?.name}}</div>

    <div>{{project?.companyName}}</div>

    <img src="./assets/img/icon-internal.svg" class="internal-user-flag-icon" *ngIf="project.isCreatedByBrotherEmployee">

</div>

<div class="cell">
    <div>{{project?.companyZip}}</div>
    <div>{{project?.companyCity}}</div>
</div>

<div class="cell">
    <span #DeviceAmountAnchor
          [ngClass]="project?.requestedProductsTotalCount > 0  && project?.devices?.length ? 'active':''"
          (mouseenter)="onDeviceAmountMouseEnter(DeviceAmountAnchor)"
          (mouseleave)="onDeviceAmountMouseLeave()">
        {{project?.requestedProductsTotalCount}}
    </span>
</div>

<div class="cell">
    <span>{{project?.rolloutStart | date:'dd.MM.yy' }} - {{project?.rolloutEnd | date:'dd.MM.yy'  }}</span>
</div>

<div class="cell">
    <span>{{project?.validityOfQuotation | date:'dd.MM.yy' }}</span>
</div>

<div class="cell cell-progress-bar hover-enabled">
    <div #ProgressBarAnchor (mouseenter)="onProgressBarMouseEnter( ProgressBarAnchor, -380 )"
         (mouseleave)="onProgressBarMouseLeave()">
        <app-project-status-progress-bar [status]="projectStatusEnum[project.status]" [date]="project.lastUpdated">
        </app-project-status-progress-bar>
    </div>

    <div class="img-container" #IconAnchor (mouseenter)="onProgressBarMouseEnter( IconAnchor, -250 )"
         (mouseleave)="onProgressBarMouseLeave()">
        <img *ngIf="getProjectStatusIcon(project); let srcPath" [src]="srcPath" alt="warning_icon">
    </div>


</div>

<div class="cell actions active" [ngClass]="{'lock-info': showLockInfo( project )}" (mouseleave)="setCloseMenuTimer()" (mouseenter)="removeCloseMenuTimer()">

    <bd-fa-button name="lock" class="lock-icon" *ngIf="showLockInfo( project )"></bd-fa-button>

    <button type="button" class="button invisible-button no-focus" (click)="onActionsBtnClicked()"
            [ngClass]="{'disabled':isActionBntDisabled()}"
            [disabled]="isActionBntDisabled()">
        <bd-fa-button class="button" [name]="'cog'">
        </bd-fa-button>
    </button>


    <app-actions-menu (menuItemClicked)="onActionsMenuItemClicked( $event )"
                      (mouseleave)="closeActionsMenu()" (mouseenter)="removeCloseMenuTimer()"
                      [menuItems]="getActionMenuItems()"
                      [projectListItem]="project"
                      #actionMenu>

    </app-actions-menu>



    <div class="lock" *ngIf="project.isLocked"
         #lockAnchor
         (mouseenter)="onLockInfoMouseEnter( lockAnchor )"
         (mouseleave)="onLockInfoMouseLeave()">
        <span>Gesperrt</span>
    </div>

</div>
